import { useSelector } from 'react-redux';
import { Card } from 'components/v4/Card';
import { VStack } from '@chakra-ui/react';
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Button,
    Text,
} from 'components/v4';
import Image from 'components/v4/Image';

import CardDetails from '../components/CardDetails';

const walkthroughIdModal = {
    ufCancelButton: '/services-profile-add/modal/confirmation/cancel',
    ufAddButton: '/services-profile-add/modal/confirmation/add',
};

const ConfirmationModal = ({
    onClose,
    isOpen,
    handleSubmit,
    serviceProfile,
    imageSrc,
    serviceName,
    description,
    isNewDashboard = false,
}) => {
    // (3082) The card resolves vendor and operator logos/names, which
    // CardDetails does not know about, so prefer what the card passes in.
    const cardDetails = CardDetails(serviceProfile.serviceType);
    const { colorScheme } = useSelector((state) => state.settings);
    const { darkMode } = useSelector((state) => state.settings);
    const name = serviceName || cardDetails?.serviceName;
    return (
        <Modal
            closeOnOverlayClick={false}
            isCentered
            isOpen={isOpen}
            onClose={onClose}
            size="md">
            <ModalOverlay backdropFilter="blur(10px)" />
            <ModalContent as="form" onSubmit={handleSubmit}>
                <Card
                    bg={darkMode ? 'dark.tcap' : null}
                    borderRadius={10}
                    key={`addcard/${serviceProfile?.serviceType}`}
                    data-walkthroughid={`addcard/${serviceProfile?.serviceType}`}>
                    <ModalHeader className="flex items-center justify-center">
                        <VStack className="flex items-center">
                            <Image
                                className="mr-2 rounded-xl"
                                src={imageSrc || cardDetails?.icon}
                                boxSize="50px"
                                objectFit="contain"
                            />
                            {/* (3135) The new dashboard asks "Add Zoom?" */}
                            <Text>
                                {isNewDashboard ? `Add ${name}?` : name}
                            </Text>
                        </VStack>
                    </ModalHeader>
                    <ModalBody>
                        <p className="text-base">
                            {description || cardDetails?.addDescription}
                        </p>
                    </ModalBody>
                    <ModalFooter className="flex justify-center">
                        <Button
                            type="button"
                            variant="outline"
                            className="secondary mr-4 !w-full"
                            onClick={onClose}
                            data-walkthroughid={
                                walkthroughIdModal.ufCancelButton
                            }>
                            Cancel
                        </Button>
                        <Button
                            bg={`${colorScheme}.500`}
                            _hover={{
                                bg: `${colorScheme}.600`,
                            }}
                            className={`flex min-h-[38px] !w-full items-center justify-center rounded-md px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--chakra-colors-${colorScheme}-600)]`}
                            type="submit"
                            data-walkthroughid={walkthroughIdModal.ufAddButton}>
                            {isNewDashboard ? 'Add service' : 'Confirm'}
                        </Button>
                    </ModalFooter>
                </Card>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmationModal;
